// Angular imports
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

// CC-Common imports
import { DxWidgetUtils, IconConstants, Utils } from 'cc-common';

// Devextream imports
import { DxPopupComponent } from 'devextreme-angular';

// Service imports
import { VendorContractService } from '../../../_services/vendor-contracts.service';
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { HelperService } from '../../../../../_services/shared-services/helper.service';

// Model imports
import { FileInfoDisplayResultDto } from '../../../../../_models/file-info-display-result-dto';
import { VendorContractBaseParameterDto } from '../../../_models/vendor-contract-base-parameter-dto';
import { DownloadVendorContractDocumentParameterDto } from '../../../_models/download-vendor-contract-document-parameter-dto';
import { CommunityVendorBaseParametersDto } from '../../../_models/community-vendor-base-parameters-dto';

@Component({
    selector: 'app-manage-contract-document',
    templateUrl: './manage-contract-document.component.html',
    styleUrls: ['./manage-contract-document.component.scss']
})
export class ManageContractDocumentComponent implements OnInit {
    @ViewChild('contractDocumentPopup', { static: false }) contractDocumentPopup: DxPopupComponent;

    @Input() popupTitle: string;
    @Input() vendorContractId: number;
    @Input() communityId: number;
    @Input() communityVendorId: number;
    @Input() vendorCode: string;

    @Output() onClose = new EventEmitter<void>();
    @Output() onDocumentSelect = new EventEmitter<any>();

    iconDelete = IconConstants.DELETE;
    iconClose = IconConstants.CLOSE;
    iconAdd = IconConstants.ADD;
    iconAttach = IconConstants.ATTACHMENT;

    visible = false;
    contractDocuments: FileInfoDisplayResultDto[];
    loadingVisible = false;

    constructor(
        private readonly helperService: HelperService,
        private readonly errorService: ServerErrorService,
        private readonly vendorContractService: VendorContractService
    ) {}

    ngOnInit() {
        this.show();
        this.contractDocuments = [];
        if (Utils.equalsIgnoreCase(this.popupTitle, 'Contract Documents')) {
            this.populateContractDocument();
        } else {
            this.populateContractAttachDocuments();
        }
    }

    onShown(): void {
        DxWidgetUtils.instantRepaint(this.contractDocumentPopup);
    }

    show(): void {
        this.visible = true;
    }

    onHidden(): void {
        this.visible = false;
        this.onClose.emit();
    }

    onAttachClick(data: FileInfoDisplayResultDto): void {
        this.onDocumentSelect.emit(data);
        this.onHidden();
    }

    onDocumentClick(data: FileInfoDisplayResultDto): void {
        const file = data;
        const param: DownloadVendorContractDocumentParameterDto = new DownloadVendorContractDocumentParameterDto();
        param.communityId = this.communityId;
        param.communityVendorId = this.communityVendorId;
        param.fileId = file.fileId;
        param.vendorContractId = this.vendorContractId;
        param.vendorCode = this.vendorCode;
        param.clearCache = true;
        this.loadingVisible = true;
        this.vendorContractService.downloadContractDocument(param).subscribe(
            (result: Blob) => {
                const fileData = result;
                this.helperService.showBlobInBrowserTab(fileData, file.fileName);
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    private populateContractDocument(): void {
        const param: VendorContractBaseParameterDto = new VendorContractBaseParameterDto();
        param.vendorContractId = this.vendorContractId;
        param.communityId = this.communityId;
        param.communityVendorId = this.communityVendorId;
        param.vendorCode = this.vendorCode;
        param.clearCache = true;
        this.loadingVisible = true;
        this.vendorContractService.getContractDocument(param).subscribe(
            (result: FileInfoDisplayResultDto[]) => {
                this.contractDocuments = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }

    private populateContractAttachDocuments(): void {
        const param: CommunityVendorBaseParametersDto = new CommunityVendorBaseParametersDto();
        param.communityId = this.communityId;
        param.communityVendorId = this.communityVendorId;
        param.vendorCode = this.vendorCode;
        param.clearCache = true;
        this.loadingVisible = true;
        this.vendorContractService.getContractAttachedDocument(param).subscribe(
            (result: FileInfoDisplayResultDto[]) => {
                this.contractDocuments = result;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
